import {isCategoriesFilterTabVisible} from '../ParticipantsTabs/CategoryFilterParticipants/isCategoriesFilterTabVisible';
import {isFavoriteParticipantsFilterTabActive} from '../ParticipantsTabs/FavoriteParticipants/isFavoriteParticipantsFilterTabActive';
import {isMyContactsFilterTabActive} from '../ParticipantsTabs/MyContacts/isMyContactsFilterTabActive';
import {isSuggestedParticipantsTabSelected} from '../ParticipantsTabs/SuggestedParticipants/isSuggestedParticipantsTabSelected';
import {isTextSearchFilterTabActive} from '../ParticipantsTabs/TextSearchParticipants/isTextSearchFilterTabActive';

export function isFilterHintVisible(filterParams, suggestedFilterParams, categories) {
    return (
        isCategoriesFilterTabVisible(categories) &&
        !Object.keys(filterParams.categories ?? {}).length &&
        !isFavoriteParticipantsFilterTabActive(filterParams) &&
        !isMyContactsFilterTabActive(filterParams) &&
        !isTextSearchFilterTabActive(filterParams) &&
        !isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams)
    );
}
